import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import {
  Button, Card, CardBody, CardHeader, CardTitle, Col,
  FormGroup, Label,
  Modal, ModalBody
} from "reactstrap";
import Select from "react-select";
import { Check } from "react-feather";
import Radio from "../../theme/@vuexy/radio/RadioVuexy";
import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import ContentSelector from "../elements/contentSelector";
import CustomerSelector from "../elements/customerSelector";
import ActivityStore from "../../stores/activityStore";
import { IListItem } from "../../types/IList";

interface IFilterSectionProps{
  activityStore: ActivityStore
}

interface IFilterSectionState{
  showDocumentModal: boolean,
  showCustomerModal: boolean
}

@inject('sessionStore', 'activityStore')
@observer
class FiltersSection extends Component<IFilterSectionProps, IFilterSectionState> {

  state = {
    showDocumentModal: false,
    showCustomerModal: false,
  }

  componentDidMount() {
    const { activityStore } = this.props;
    activityStore.loadDocuments();
    activityStore.loadCustomers();
    activityStore.loadSideBarFilterData();
  }

  handleRadio = (e:any) => {
    const { activityStore } = this.props;
    activityStore.setActivityFilter({ timeline: e.target.value });
    activityStore.loadActivities();
  }

  setCustomer = (o:any) => {
    const { activityStore } = this.props;
    activityStore.setActivityFilter({ customerId: o.value.uid });
    activityStore.loadActivities();
  }

  setDocument = (o:any) => {
    const { activityStore } = this.props;
    activityStore.setActivityFilter({ contentId: o.value.uid });
    activityStore.loadActivities();
  }

  handleCheckbox = (value:any, add?: boolean) => {
    const { activityStore } = this.props;
    activityStore.setActivityFilter({ activityTypes: [value] });
    activityStore.loadActivities();
  }

  clearAllFilters = (value:any) => {
    const { activityStore } = this.props;
    activityStore.clearAllFilters();
    activityStore.loadActivities();
  }

  toggleDocumentModal = () => {
    this.setState((prevState) => ({
      showDocumentModal: !prevState.showDocumentModal
    }))
  }

  toggleCustomerModal = () => {
    this.setState((prevState) => ({
      showCustomerModal: !prevState.showCustomerModal
    }))
  }

  render() {
    const { activityStore } = this.props;
    const { activityFilter, customers, documents, eventList, timelineList } = activityStore

    const docOptions = documents ? documents.map((doc) => {
      return { value: doc, label: doc.name }
    }) : []

    const custOptions = customers ? customers.map((cust) => {
      return { value: cust, label: cust.account.firstName + ' ' + cust.account.lastName }
    }) : []

    const selectedDocId = activityFilter.contentId;
    const selectedDocIndex = selectedDocId ? docOptions.findIndex((doc) => doc.value.uid === selectedDocId) : null;

    const selectedCustId = activityFilter.customerId;
    const selectedCustIndex = selectedCustId ? custOptions.findIndex((cust) => cust.value.uid === selectedCustId) : null;

    const timelineComp = timelineList && timelineList.map((item: IListItem, index:number) => {
      return (
        <li  key={index}>
          <Radio
            label={item.name}
            checked={activityFilter.timeline == item.value}
            name="timeline"
            value={item.value}
            className="py-25"
            onClick={this.handleRadio}
          />
          
        </li>
      )
    })

    const eventComp = eventList && eventList.map((item:IListItem, index:number) => {
      return (
        <li key={index} className="py-25">
          <Checkbox
            color="primary"
            name="activityType"
            icon={<Check className="vx-icon" size={16} />}
            label={item.name}
            onClick={(e:any) => { this.handleCheckbox(`${item.value}`, e.target.checked) }}
            checked={activityFilter.activityTypes.includes(item.value)}
          />
        </li>
      );
    })

    const customerComp =
      <Button
        className="btn block"
        color="primary"
        outline
        onClick={this.toggleCustomerModal}
      >
        Select Customer
      </Button>

    const documentComp =
      <Button
        className="btn block"
        color="primary"
        outline
        onClick={this.toggleDocumentModal}
      >
        Select Document
      </Button>



    const documentModal = (<Modal
      isOpen={this.state.showDocumentModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <span className="heading">Select Content</span>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleDocumentModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <ContentSelector
          contentSharing="activity"
          toggle={this.toggleDocumentModal}
        />
      </div>
    </Modal>)

    const customerModal = (<Modal
      isOpen={this.state.showCustomerModal}
      className="modal-dialog-centered modal-xl"
    >
      <div className="sidebar_header">
        <span className="heading">Select Content</span>
        <div>
          <Button
            color="danger"
            outline
            className="btn ml-1"
            onClick={this.toggleCustomerModal}
          >
            Cancel
            </Button>
        </div>
      </div>
      <div className="sidebar_content">
        <CustomerSelector
          contentSharing="activity"
          toggle={this.toggleCustomerModal}
        />
      </div>
    </Modal>)


    return (
      <Fragment>
        <h6 className="filter-heading d-none d-lg-block">Filters</h6>
        <Card>
          <CardBody className="p-2">
            <div className="brands">
              <div className="brand-title mt-1 pb-1">
                <h6 className="filter-title mb-0">Timeline</h6>
              </div>
              <div className="brand-list">
                <ul className="list-unstyled brand-list">
                  {timelineComp}
                </ul>
              </div>
            </div>
            <hr />
            <div className="multi-range-price">
              <div className="multi-range-title pb-75">
                <h6 className="filter-title mb-0">Event</h6>
              </div>
              <ul className="list-unstyled price-range">
                {eventComp}
              </ul>
            </div>
            <hr />
            <div>
              <div className="multi-range-title pb-75">
                <h6 className="filter-title mb-0">Customer</h6>
              </div>
              {customerComp}
            </div>
            <hr />
            <div>
              <div className="multi-range-title pb-75">
                <h6 className="filter-title mb-0">Document</h6>
              </div>
              {documentComp}
            </div>
            <br />
          </CardBody>
        </Card>
        {documentModal}
        {customerModal}
      </Fragment>
    );
  }
}

export default FiltersSection;